
const staffingOfferings = [
  {
    title: 'Contract Staffing',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/contract_staffing.png',
    imageAlt: 'Technology professionals collaborating on a defined project',
    description: 'Add experienced professionals for defined projects and changing workloads while keeping your team flexible.',
  },
  {
    title: 'Temporary Staffing',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/temporary.png',
    imageAlt: 'Technology specialist supporting a team during a busy period',
    description: 'Cover short-term gaps and busy periods with specialists who can step in quickly and keep work moving.',
  },
  {
    title: 'Permanent Staffing',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/permenant.png',
    imageAlt: 'New professional meeting a team in an office',
    description: 'Find full-time talent through careful screening of skills, experience and fit for your team.',
  },
  {
    title: 'Contract-To-Hire',
    image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Staff%20Augementation/contract-to-hire.png',
    imageAlt: 'Team lead and technology professional discussing a longer-term role',
    description: 'Work with a professional on contract first, then decide on a permanent role with greater confidence.',
  },
];

export default function StaffingOfferings() {
  return (<section className="bg-white px-5 py-16 sm:px-6 lg:px-10 lg:py-12" aria-labelledby="staffing-offerings-title">
      <div className="mx-auto max-w-[1360px]">
        <div className="max-w-7xl">
          <h2 id="staffing-offerings-title" className="text-center text-[32px] font-semibold leading-[48px]" style={{ color: '#183762', marginBottom: 0 }}>Check Out Our Offerings in Staffing Delivery Models</h2>
          <p className="mt-5 text-center text-base font-normal leading-[27px]" style={{ color: '#212121' }}>Choose the level of support and commitment that fits the way your team works.</p>
        </div>
        <div className="mt-10 grid gap-3 sm:grid-cols-2 xl:grid-cols-4 xl:gap-4">
          {staffingOfferings.map((offering) => <article key={offering.title} className="overflow-hidden rounded-2xl border border-[#E3E8EF] bg-white">
            <div className="flex justify-center px-6 pt-5 sm:px-8">
              <img src={offering.image} alt={offering.imageAlt} loading="lazy" className="h-40 w-full max-w-[360px] object-contain" />
            </div>
            <div className="px-6 pb-6 pt-3 sm:px-8 sm:pb-8 sm:pt-4">
              <h3 className="whitespace-nowrap text-xl font-semibold leading-tight underline decoration-[#86B4CC] decoration-2 underline-offset-[6px] sm:text-[21px]" style={{ color: '#183762', marginBottom: 0 }}>{offering.title}</h3>
              <p className="mt-6 text-base font-normal leading-[27px]" style={{ color: '#212121', textAlign: 'left', hyphens: 'none', wordSpacing: 'normal' }}>{offering.description}</p>
            </div>
          </article>)}
        </div>
      </div>
    </section>);
}
